import { PublicPage } from 'components/PublicPage'
import { useIsStandardUUID } from 'scripts/hooks/useIsStandardUUID';
interface IPageNotFound404Props {
    statusCode?: number;
}

// // UUID v4 (strict about version & variant bits)
// const UUIDv4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

// // If you just need "any UUID" (v1–v5), drop the version/variant checks:
// const UUID_ANY = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const PageNotFound404 = (props: IPageNotFound404Props): JSX.Element => {
    const { statusCode } = props;

    const isLikelyChatSession = useIsStandardUUID();

    const condition = isLikelyChatSession && statusCode === 404;

    const title = condition ? "Conversation Not Found" : "404 – Page Not Found";

    const description = condition
        ? "We couldn’t find a conversation with the session ID you entered. It may have been deleted, expired, or never existed. For more help, visit our"
        : "Looks like this page is missing. If you still need help, visit our";

    const reasons = condition
        ? [
            "The session ID was typed incorrectly",
            "The conversation has been removed",
            "The chat session is private or expired"
        ]
        : [
            "The URL (page address) was entered incorrectly",
            "The page has moved",
            "The page no longer exists"
        ];

    const buttonTitle = condition ? "Start a New Chat" : "Back to AI Mode";

    return (
        <PublicPage
            title={title}
            description={description}
            reasons={reasons}
            buttonTitle={buttonTitle}
        />
    )
}
